import { lazy } from 'react';

/**
 * El aviso de pedidos de permiso del menú del super administrador, a pedido y con su proveedor de
 * consultas. La raíz dibuja el menú por encima de los grupos, que son los que montan el proveedor,
 * así que el aviso trae el suyo: el mismo cliente, para compartir la caché con la reapertura.
 *
 * El 2026-10-01 iba sin él, y el super administrador no pudo entrar: «No QueryClient set» tumbaba la
 * aplicación entera justo después del ingreso. Las pruebas no lo vieron porque montan el aviso
 * dentro de un proveedor, y los recorridos del navegador no entran como super administrador.
 */
export const AvisoPedidosPerezoso = lazy(async () => {
  const [{ AvisoPedidos }, { ConConsultas }] = await Promise.all([
    import('../funcionalidades/reapertura-jornada/AvisoPedidos.js'),
    import('./consultas.js'),
  ]);
  return {
    default: function AvisoConConsultas() {
      return (
        <ConConsultas>
          <AvisoPedidos />
        </ConConsultas>
      );
    },
  };
});
